import classNames from "classnames";
import PropTypes from "prop-types";
import classes from "./Card.module.scss";

export const Card = ({
  noShadow,
  heightAuto,
  children,
  onClick,
  className,
}) => {
  const handleClickEvent = (e) => {
    e.stopPropagation();
    onClick();
  };
  return (
    <div
      data-testid={"card"}
      className={classNames(className, "relative", classes.card, {
        [classes["height-auto"]]: heightAuto,
        [classes["no-shadow"]]: noShadow,
      })}
      onClick={onClick && handleClickEvent}
    >
      {children}
    </div>
  );
};

Card.propTypes = {
  /**
   * use this flag to ignore shadow around the card
   */
  noShadow: PropTypes.bool,
  /**
   * set true for height auto otherwise it's 100%
   */
  heightAuto: PropTypes.bool,
  /**
   * onClick function
   */
  onClick: PropTypes.func,
};

Card.defaultProps = {
  noShadow: false,
  heightAuto: false,
  onClick: undefined,
};
